import React from 'react';
import classnames from 'classnames';
import PresenterDetails from './PresenterDetails';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import {formattingDate} from '../../../utils/formatting';
import {getSelectedOptionLabel} from '../../../utils/options';
import styles from './styles.module.scss';

const Section2Text = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    visitDate,
    visitorName,
    visitorJob,
  } = context.data.pdfData;
  const visitorJobValue = getSelectedOptionLabel(visitorJob, context.options.visitorJobOptions);
  const visitorNameAndJob = `${visitorName}, ${visitorJobValue}`;
  const visitDateValue = Boolean(visitDate) ? formattingDate(visitDate) : '';

  return (
    <div
      className={classnames(styles.itemText, styles.innerPadding, styles.listItem)}
      style={{marginBottom: 0}}
      ref={ref}
    >
      <span style={{paddingLeft: 10}}>א.</span>
      <div>
        <span>
       בתאריך {visitDateValue} נערך ביקור בנכס ובסביבתו
      ע"י {visitorNameAndJob}
      </span>
        <PresenterDetails/>
      </div>
    </div>
  );
});

export default Section2Text;
